<div class="flex gap-4 items-center text-xs text-neutral-500 font-bold">
  <h1 class="flex min-w-0 items-center gap-1">
    <i class="ph ph-tree-structure text-base font-normal"></i>
    <span class="truncate">Process definition:</span>
    <span
      class="shrink-0 text-black"
      data-testid="process-definition-name"
      >{{ name() }}</span
    >
  </h1>
  <h1 class="relative flex min-w-0 flex-row gap-2">
    <span class="truncate">Active process instance:</span>
    <div class="flex items-center">
      <div
        class="truncate w-14 text-black"
        data-testid="process-instance-uuid"
      >
        {{ uuid() }}
      </div>
      <flx-icon
        [name]="!copiedTextToClipboard ? 'copy' : 'circle-check'"
        [class.text-green-300]="copiedTextToClipboard"
        [cdkCopyToClipboard]="uuid()"
        (cdkCopyToClipboardCopied)="onCopyToClipboardSuccess()"
        class="cursor-pointer"
      ></flx-icon>
    </div>
  </h1>
  <p-tag
    [value]="state()"
    [severity]="severity()"
    class="flx-tag flex"
    data-testid="process-instance-status"
  />
</div>
